import { render, staticRenderFns } from "./FooterCareer.vue?vue&type=template&id=55eb71d5&scoped=true"
var script = {}
import style0 from "./FooterCareer.vue?vue&type=style&index=0&id=55eb71d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eb71d5",
  null
  
)

export default component.exports